// 縮減文字至指定字數 超過加...
export const sliceText = (text = '', max = 30, append = '...') => {
  if (text.length > max) {
    return text.slice(0, 30) + append;
  }

  return text;
};
